import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Validate bulk onboarding payload (company + superuser + users)
 */
export const validateBulkOnboard = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/companies/bulk-onboard/validate`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};

/**
 * Create bulk onboard (company + superuser + users)
 */
export const upsertBulkOnboard = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/companies/bulk-onboard`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};
